export default "__VITE_ASSET__BrPGYieu__"